import * as React from 'react';
import DefaultButton from '../default-button/default-button';
import classnames from 'classnames';
import { IMultiSelectClosedPropsDerivedFromItemsList } from './make-multi-select-in-popover';
import { makePresenterGroupsMultiSelect } from './make-presenter-groups-multi-select';

type IPresenterGroupsMultiSelectButtonProps = {
    text: React.ReactNode;
    className?: string;
    onClick?: () => void;
};

const PresenterGroupsMultiSelectButton = makePresenterGroupsMultiSelect(
    React.forwardRef((props: IPresenterGroupsMultiSelectButtonProps & IMultiSelectClosedPropsDerivedFromItemsList, ref: React.Ref<HTMLButtonElement>) => {
        const { text, isOpen, onClick, className } = props;

        return (
            <DefaultButton
                text={text}
                ref={ref}
                onClick={() => isOpen && onClick && onClick()}
                className={classnames(className, {
                    'active': isOpen
                })}
            />
        );
    })
);

export { PresenterGroupsMultiSelectButton, IPresenterGroupsMultiSelectButtonProps };
